module.exports = require("@azure/functions-core");